import links from "./links"

export const headerDesktopLinks = [
  {
    ...links.FEATURES,
    type: "FEATURES",
    href: undefined,
  },
  {
    ...links.USE_CASES,
    type: "USE_CASES",
    href: undefined,
  },
  {
    type: "PRICING",
    ...links.PRICING,
  },
  {
    type: "COMPANY",
    ...links.COMPANY,
    href: undefined,
  },
  {
    type: "BLOG",
    ...links.BLOG,
  },
]
